var map = {
	"./icon-address.svg": 94744,
	"./icon-back.svg": 2336,
	"./icon-case.svg": 24487,
	"./icon-chain.svg": 40822,
	"./icon-circulate.svg": 68622,
	"./icon-company.svg": 26902,
	"./icon-complement.svg": 6471,
	"./icon-cooperate.svg": 77316,
	"./icon-dianhua.svg": 63237,
	"./icon-download.svg": 17305,
	"./icon-email.svg": 54625,
	"./icon-export.svg": 25897,
	"./icon-goods.svg": 26806,
	"./icon-gou.svg": 79270,
	"./icon-gouwuche.svg": 13974,
	"./icon-handshake.svg": 32058,
	"./icon-heart.svg": 14887,
	"./icon-import.svg": 39781,
	"./icon-interest.svg": 793,
	"./icon-interlinkage.svg": 6267,
	"./icon-language.svg": 56799,
	"./icon-malawei.svg": 89060,
	"./icon-menu.svg": 35501,
	"./icon-money.svg": 27841,
	"./icon-national.svg": 68218,
	"./icon-national1.svg": 26493,
	"./icon-national2.svg": 18524,
	"./icon-national3.svg": 31705,
	"./icon-news.svg": 43755,
	"./icon-offer-1.svg": 44583,
	"./icon-offer-2.svg": 15233,
	"./icon-offer-3.svg": 45572,
	"./icon-offer-4.svg": 7851,
	"./icon-offer-5.svg": 42735,
	"./icon-offer-6.svg": 95380,
	"./icon-offer-7.svg": 27240,
	"./icon-offer-8.svg": 93180,
	"./icon-phone.svg": 82433,
	"./icon-ping.svg": 87352,
	"./icon-price.svg": 17488,
	"./icon-search.svg": 63732,
	"./icon-shang.svg": 4255,
	"./icon-shangjiantou.svg": 13853,
	"./icon-shijian.svg": 1367,
	"./icon-ship.svg": 34303,
	"./icon-skill-1.svg": 93869,
	"./icon-skill-2.svg": 41999,
	"./icon-skill-3.svg": 52575,
	"./icon-skill-4.svg": 61155,
	"./icon-video.svg": 96135,
	"./icon-xia.svg": 36828,
	"./icon-xiajiantou.svg": 56285,
	"./icon-youjiantou.svg": 89703,
	"./icon-youshi.svg": 36193,
	"./icon-zuojiantou.svg": 93864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;